import React, { useState } from 'react';
import { Plus, Minus, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const objections = [{
  question: '¿Y si recién empiezo y todavía no tengo muchos pacientes?',
  answer: 'Justamente este sistema está pensado para que arranques con bases profesionales sólidas. Vas a tener desde el día uno todo lo que un consultorio establecido tiene: plantillas, protocolos, casos resueltos y seguimiento. Te ahorra años de prueba y error.'
}, {
  question: '¿Cómo voy a recibir el material?',
  answer: 'Apenas hacés el pago, recibís un email con el acceso inmediato a todo el contenido en formato PDF + las plantillas editables en Google Sheets. Sin esperas, sin envíos físicos.'
}, {
  question: '¿Sirve si ya tengo experiencia y consultorio armado?',
  answer: 'Sí. La mayoría de los nutricionistas que lo usan ya tienen experiencia y lo que buscan es ordenar, sistematizar y profesionalizar lo que ya hacen. Te va a permitir trabajar más rápido y con mejores resultados.'
}, {
  question: '¿Las plantillas son editables?',
  answer: 'Las plantillas son completamente editables.'
}, {
  question: '¿Por qué el precio es tan accesible?',
  answer: 'Es una promoción de lanzamiento por tiempo limitado. El precio regular es $59.990, pero solo por hoy podés acceder a $19.990. Una vez agotados los cupones disponibles, vuelve al precio normal.'
}, {
  question: '¿Tiene actualizaciones?',
  answer: 'Sí. Una vez que comprás, accedés a todas las actualizaciones futuras sin costo adicional. El sistema se mantiene vivo y crece con vos.'
}, {
  question: '¿Puedo aplicarlo a pacientes deportistas y clínicos por igual?',
  answer: 'Sí. El Megapack incluye un tomo completo de nutrición deportiva aplicada y otros con casos clínicos variados: sobrepeso, ansiedad alimentaria, resistencia a la insulina, alimentación emocional y mucho más.'
}];
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-165">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-167">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-5 py-2 rounded-full text-sm font-bold mb-4" data-id="element-168">
            <HelpCircle className="w-4 h-4" data-id="element-169" />
            DUDAS FRECUENTES
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-170">
            Resolvemos tus{' '}
            <span className="text-emerald-600" data-id="element-171">últimas dudas</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-172">
            Todo lo que necesitás saber antes de tomar la decisión
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-173">
          {objections.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.4
        }} className="bg-emerald-50 border-2 border-emerald-100 rounded-2xl overflow-hidden hover:border-emerald-300 transition-colors duration-300" data-id="element-174">
              <button onClick={() => toggle(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-emerald-100/50 transition-colors duration-200" data-id="element-175">
                <span className="font-bold text-slate-900 text-base md:text-lg pr-4" data-id="element-176">
                  {item.question}
                </span>
                <div className="bg-emerald-600 text-white rounded-full p-1.5 flex-shrink-0" data-id="element-177">
                  {openIndex === index ? <Minus className="w-4 h-4" data-id="element-178" /> : <Plus className="w-4 h-4" data-id="element-179" />}
                </div>
              </button>

              <AnimatePresence data-id="element-180">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-181">
                    <div className="px-6 pb-5" data-id="element-182">
                      <p className="text-slate-700 leading-relaxed" data-id="element-183">
                        {item.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}